// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"8be86217","633":"a7d13dfb","816":"2f16df10"}[chunkId] + ".chunk.js";
};